import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import "./index.scss";



@inject('store')
@observer
class index extends Component {

    componentDidMount() {
        window.addEventListener('resize', () => {
            if (window.location.hash === '#/table/groupOfChannels') {
                this.props.store.criticism.setChart([], true);
            }
        });
    }

    render() {
        return (
            <div id="chart" style={{ height: 500, width: '100%', background: '#fff' }}></div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/guestRating/channels/chart.js